<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const { accountId } = useAccount();

const pricingUrl = computed(
  () =>
    `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/payments/new`
);
</script>

<template>
  <NervenetFrame :src="pricingUrl" />
</template>
